var firebase = require('../firebase');
var toastr = require('toastr');

var { fbDb } = firebase;

var count = 0;

module.exports = {
	fetching: function() {
		return {
			type: "DATA_FETCHING"
		};
	},

	checking: function() {
		return {
			type: "DATA_CHECKING"
		};
	},

	createCourierSuccess: function(courier) {
		return {
			type: "CREATE_COURIER_SUCCESS",
			payload: courier
		};
	},

	loadCouriersSuccess: function(couriers) {
		return {
			type: "LOAD_COURIERS_SUCCESS",
			payload: couriers
		};
	},

	updateCourierSuccess: function(courier) {
		return {
			type: "UPDATE_COURIER_SUCCESS",
			payload: courier
		};
	},

	updateFilesSuccess: function(courier) {
		return {
			type: "UPDATE_FILES_SUCCESS",
			payload: courier
		};
	},

	updateFilesError: function(error) {
		return {
			type: "UPDATE_FILES_ERROR",
			payload: error
		};
	},

	deleteCourierSuccess: function(courier) {
		return {
			type: "DELETE_COURIER_SUCCESS",
			payload: courier
		};
	},

	unloadCouriers: function() {
		return {
			type: "UNLOAD_COURIERS"
		}
	},

	update: function(key, data) {
		return new Promise((resolve, reject) => {
			fbDb.ref(`couriers/${key}`)
			.update(data, error => error ? reject(error) : resolve());
		});
	},

	remove: function(key) {
		return new Promise((resolve, reject) => {
			fbDb.ref(`couriers/${key}`)
			.remove(error => error ? reject(error) : resolve());
		});
	},

	getCourierRate: function(data) {
		var median;

		if (!data) return 0;

		median = data.evaluationSum / data.evaluationCount;

		return median ? (Math.round( median * 10) / 10) : 0;
	},

	unwrapCourier: function(snap) {
		var me = this, courier = snap.val(), rating = me.getCourierRate(courier.info);

		return Object.assign(
			{}, 
			courier.info,
			{ 
				id: snap.key, 
				status: courier.status,
				worldTennisAttendant: courier.worldTennisAttendant,
				rating: rating,
				moneyCredit: courier.moneyCredit,
				tokenId: courier.tokenId,
				avatar: null,
				driverLicense: null,
				vehicle: null,
				vehicleLicense: null
			}
		);
	},

	loadCouriers: function() {
		var me = this;

		return function(dispatch) {
			var ref = fbDb.ref('couriers').orderByChild("createdAt"), 
				list = [],
				initialized = false;

			ref.once('value', (couriers) => {
				initialized = true;

				dispatch(me.loadCouriersSuccess(list));
			});

			ref.on('child_added', snap => {
				var courier = me.unwrapCourier(snap);

				if (initialized)
					dispatch(me.createCourierSuccess(courier));
				else
					list.unshift(courier);
			});

			ref.on('child_changed', snap => {
				var courier = me.unwrapCourier(snap);

				dispatch(me.updateCourierSuccess(courier));
			});

			ref.on('child_removed', snap => {
				var courier = me.unwrapCourier(snap);

				dispatch(me.deleteCourierSuccess(courier));
			});

			me._unsubscribe = () => ref.off();

			dispatch(me.fetching());
		}
	},

	unsubscribe: function() {
		var me = this;

		return function(dispatch) {
			me._unsubscribe();
			
			dispatch(me.unloadCouriers());
		};
	},

	updateCourier: function(key, data) {
		var me = this;

		return function(dispatch) {
			me.update(key, data)
			.then(() => {
				toastr.success('O usuário foi atualizado com sucesso.');
			})
			.catch(() => {
				toastr.error('Ocorreu um erro ao atualizar o registro.');
			})
		}
	},

	removeCourier: function(key) {
		var me = this;

		return function(dispatch) {
			me.remove(key)
			.then(() => {
				toastr.success('O usuário foi excluído com sucesso.');
			})
			.catch(() => {
				toastr.error('Ocorreu um erro ao remover o registro.');
			})
		}
	}
};


// WEBPACK FOOTER //
// ./src/actions/courierActions.js